import { all } from "redux-saga/effects";

import { saga as obterZonasGeo } from "./actions/obterZonasGeo";
import { saga as obterAreasEspeciaisGeo } from "./actions/obterAreasEspeciaisGeo";
import { saga as obterPlanoDiretorNoPonto } from "./actions/obterPlanoDiretorNoPonto";
import { saga as obterZonaPorSigla } from "./actions/obterZonaPorSigla";
import { saga as obterAnexo } from "./actions/obterAnexo";

export default all([
  obterZonasGeo,
  obterAreasEspeciaisGeo,
  obterPlanoDiretorNoPonto,
  obterZonaPorSigla,
  obterAnexo
]);
